module.exports = __webpack_public_path__ + "static/img_1005-ce780420278468284b65b90bf988fed1.webp";